import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "banner-slide-area" }
const _hoisted_2 = { class: "banner-content-wrap" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = {
  class: "banner-content",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "100"
}
const _hoisted_5 = { class: "top-title" }
const _hoisted_6 = { class: "banner-cta" }
const _hoisted_7 = { class: "border-style" }
const _hoisted_8 = { class: "ps-0 mb-0 list-unstyled d-flex align-items-center flex-wrap several-list gap-2 gap-lg-3 justify-content-center" }
const _hoisted_9 = {
  class: "partner-logo ps-0 mb-0 list-unstyled d-none d-md-flex justify-content-lg-between flex-wrap gap-3 align-items-center justify-content-center",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "200"
}
const _hoisted_10 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BannerSlideOne = _resolveComponent("BannerSlideOne")!
  const _component_BannerSlideTwo = _resolveComponent("BannerSlideTwo")!
  const _component_BannerSlideThree = _resolveComponent("BannerSlideThree")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_PartnerSlide = _resolveComponent("PartnerSlide")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BannerSlideOne, {
      "custom-images": _ctx.banner.slide_row_1 || []
    }, null, 8, ["custom-images"]),
    _createVNode(_component_BannerSlideTwo, {
      "custom-images": _ctx.banner.slide_row_2 || []
    }, null, 8, ["custom-images"]),
    _createVNode(_component_BannerSlideThree, {
      "custom-images": _ctx.banner.slide_row_3 || []
    }, null, 8, ["custom-images"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.banner.top_title), 1),
          _createElementVNode("h1", null, _toDisplayString(_ctx.banner.title), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.banner.subtitle), 1),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_RouterLink, {
              to: _ctx.banner.cta_url || '/pricing',
              class: "btn"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.banner.cta_text || "Buy Now"), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("ul", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banner.bullet_points, (point, i) => {
              return (_openBlock(), _createElementBlock("li", {
                key: i,
                class: "d-flex align-items-center"
              }, [
                _cache[0] || (_cache[0] = _createElementVNode("i", { class: "ti ti-circle-check" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(point), 1)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("ul", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.effectivePartners, (p, i) => {
            return (_openBlock(), _createElementBlock("li", { key: i }, [
              _createElementVNode("img", {
                src: p.image,
                alt: "partner"
              }, null, 8, _hoisted_10)
            ]))
          }), 128))
        ]),
        _createVNode(_component_PartnerSlide, {
          "custom-images": _ctx.banner.partner_logos || []
        }, null, 8, ["custom-images"])
      ])
    ])
  ]))
}